import { ClientInfo, CONTAINER_TYPE_MAP } from "@/api/coupon";
import { APP_VERSION } from "../constant";
import { getAppEnv } from "../getBrowserEnv";
import { getLocationInfo } from "../location";
import { getCacheUserInfo } from "../login";
import { getUuid } from "../uuid";
import { COUPON_SYSTEM_PLATFORM_MAP, COUPON_WALL_APPID_MAP } from "./constants";
import { CouponWallScene } from "@/types/coupon-wall";
import getFingerprint from "../getFingerprint";

/**
 * 构建红包墙/限时抢预发接口的 clientInfo 参数
 */
export async function getClientInfo(scene: CouponWallScene, needFP: boolean = false): Promise<ClientInfo> {
  const userInfo = getCacheUserInfo();
  const uuid = getUuid();
  const appEnv = getAppEnv();
  const locationInfo = await getLocationInfo();
  const { actualCityInfo } = locationInfo || {};
  const { openIdCipher = '', openId = '' } = userInfo || {};
  const params = {
    wm_uuid: uuid || '',
    mtFingerprint: '',
    fp_platform: appEnv.fpPlatform,
    wm_appversion: APP_VERSION,
    city_id_level2: actualCityInfo?.cityCode!,
    wm_actual_latitude: actualCityInfo?.wm_lat!,
    wm_actual_longitude: actualCityInfo?.wm_lng!,
    appId: COUPON_WALL_APPID_MAP[scene],
    open_id: openId,
    expoId: openIdCipher,
    wm_dplatform: COUPON_SYSTEM_PLATFORM_MAP[appEnv.platform],
    container: CONTAINER_TYPE_MAP[appEnv.runtimeEnv],
  } as ClientInfo;

  if (needFP) {
    const fp = await getFingerprint();
    params.mtFingerprint = fp;
  }
  return params;
}

